import {Component} from '@angular/core';

import {NewNavigationService} from "@shared/services/new-navigation.service";

@Component({
  selector: 'sm-timeout-dialog',
  templateUrl: './timeout-dialog.component.html',
})
export class TimeoutDialogComponent {

  constructor(
    private newNavigationService: NewNavigationService
  ) {
  }

  onSubmit() {
    this.newNavigationService.toLogout();
  }

}
